<div
    class="modal fade show"
    [ngClass]="{'expanded': isExpanded}"
    id="item-advance-search-modal"
    tabindex="-1"
    aria-labelledby="item-advance-search-modalLabel"
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id">
                        <h4 class="modal-title mb-0 item-id">Items</h4>
                        <!-- <h4 class="modal-title mb-0 item-id">{{ gridType === 'config' ? 'Configurations' : 'Customers' }}</h4> -->
                    </div>
                    <div class="btns-header ms-auto">
                        <button
                            class="header-icon close p-0 m-0"
                            (click)="close()"
                            aria-label="Close"
                        >
                            <i
                                class="fas fa-times"
                                title="Close Popup"
                            ></i>
                        </button>
                        <button
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="isExpanded = !isExpanded"
                        >
                            <i
                                class="fas ms-2 me-2"
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-3">
                <div class="row">
                    <div class="col">
                        <ejs-grid
                            *ngIf="mainGrid"
                            #itemsAdvancedSearchGrid
                            [height]="gridHeight"
                            [query]="query"
                            [allowPaging]="false" [enableInfiniteScrolling]="true" [enableVirtualization]="false" [enableVirtualMaskRow]="false" [infiniteScrollSettings]="infiniteScrollSettings"
                            [pageSettings]="pageSettings"
                            [dataSource]="data"
                            [allowFiltering]="true"
                            [allowResizing]="true"
                            [allowReordering]="true"
                            [allowSorting]="true"
                            [toolbar]="$safeNavigationMigration(mainGrid?.toolbar)"
                            [sortSettings]="{columns: [{field: 'onHand', direction: 'Desending'}] }"
                            [filterSettings]="{ type: 'Menu' }"
                            [allowSelection]='true'
                            (toolbarClick)="toolbarClick($event, itemsAdvancedSearchGrid)"
                            (commandClick)="onCommandClick($event)"
                            (rowSelected)='rowSelected($event)'
                            (dataBound)="onDataBound()" (created)="onGridCreated($event)"
                            (actionBegin)="onGridActionBegin($event)"
                            (actionComplete)="onGridActionComplete($event, itemsAdvancedSearchGrid)"
                            >
                            <e-columns>
                                <e-column
                                    *ngFor="let column of mainGrid.columns;"
                                    [field]="column.field"
                                    [headerText]="column.headerText"
                                    [clipMode]="'EllipsisWithTooltip'"
                                    [type]="column.type"
                                    [width]="column.width"
                                    [format]="column.format ? column.format : null"
                                    [filterType]="'contains'"
                                    [textAlign]="column.textAlign"
                                    [visible]="column.visible"
                                    [commands]="column?.commands ? column.commands : null"
                                    [filter]="column.filter ? column.filter : { type: 'Menu' }"
                                    [freeze]="column.freeze ? column.freeze: null"
                                    [allowEditing]="column.allowEditing"
                                    [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true"
                                    [allowSorting]="column.allowSorting !== undefined ? column.allowSorting : true"
                                    [allowResizing]="column.allowResizing !== undefined ? column.allowResizing : true"
                                    >
                                    <ng-template *ngIf="column.field === 'item'" #template let-data>
                                        <a href="javascript:" (click)="onCommandClick({commandColumn: {title: 'Proceed'}, rowData: data})">{{data.item}}</a>
                                    </ng-template>
                                    <ng-template *ngIf="column.field === 'itemDescription'" #template let-data>
                                        <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemDescription}}</a>
                                    </ng-template>
                                    <ng-template *ngIf="column.field === 'itemCode'" #template let-data>
                                        <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemCode}}</a>
                                    </ng-template>
                                    <ng-template *ngIf="column.field === 'status'" #template let-data>
                                        <span class="grid-status-column {{getStatusClass(data.status)}}">{{data.status}}</span>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                        <div *ngIf="mainGrid" class="grid-footer d-flex" style="justify-content:flex-end; margin-right: 20px; padding:8px 12px; border-top:1px solid #eee;">
                            <div class="grid-total-count" style="font-weight:600;">
                                Total Records: {{totalRecords | number}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

<ng-template #onHandCheckbox>
  <ejs-checkbox
    class="property-checkbox mt-1"
    *ngIf="![UserRoles.isc, UserRoles.iscManager, UserRoles.IscSupervisor].includes(USER.role)"
    [checked]="isOnHandChecked"
    [label]="'On Hand'"
    (change)="onHoldCheckboxChange($event)"
  ></ejs-checkbox>
</ng-template>
